<template>
  <el-drawer
    :title="title"
    :size="`${currentWidth}%`"
    :visible.sync="dialogVisible"
    :custom-class="customClass"
    :direction="direction"
    append-to-body
    modal-append-to-body
    :wrapperClosable="wrapperClosable"
    :close-on-press-escape="true"
    :before-close="beforeClose"
  >

    <slot />

  </el-drawer>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return "提示";
      }
    },
    direction: {
      type: String,
      default() {
        return "rtl";
      }
    },
    currentWidth: {
      type: Number,
      default() {
        return 45;
      }
    },
    wrapperClosable: {
      type: Boolean,
      default() {
        return true;
      }
    },
    customClass: {
      type: String,
      default() {
        return "";
      }
    },
    dialogVisible: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    beforeClose() {
      //console.log("beforeClose--->");
      this.$emit("closeDrawer", 1);
    }
  }
};
</script>

<style>
</style>
